import React from 'react';
import {
  Button,
  Form,
  FormGroup,
  Input,
  FormFeedback,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
} from 'reactstrap';
import Strings from '../strings/Strings';
import BaseService from '../services/BaseService';
import Loader from './Loader';
import CustomInput from './CustomInput';
import SelectAPI from './SelectAPI';
import Geocode from "react-geocode";

class UserCreate extends React.Component{
  constructor(props){
    super(props)
    this.state = {
      user: '',
      user_error: false,
      name: '', nameInvalid: false,
      email: '', emailInvalid: false,
      password: '', passwordInvalid: false,
      repassword: '', repasswordInvalid: false,
      document: '', documentInvalid: false,
      phone_number: '', phoneNumberInvalid: false,
      birthdate: '', birthdateInvalid: false,
      device: '', deviceInvalid: false,
      company_name: '', companyNameInvalid: false,
      address: '', addressInvalid: false,
      district: '', districtInvalid: false,
      address_number: '', addressNumberInvalid: false,
      state: null, stateInvalid: false,
      city: null, cityInvalid: false,
      cep: '', cepInvalid: false,
      sector: '', sectorInvalid: false,
      mask_phone: '(00) 0000-00000',
      loading: false,
      error_message: '',
      color_message: '',
      latitude: 0,
      longitude: 0,
      required_password: 'Deve ser preenchido de acordo com a regra a seguir. Deve conter: letras maiúsculas, letras minúsculas, números e no mínimo 7 caracteres',
      required_repassword: 'O campo deve ser igual ao campo senha, ambos devem conter: letras maiúsculas, letras minúsculas, números e no mínimo 7 caracteres',

    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.toggle = this.toggle.bind(this);
    this.valid_field = this.valid_field.bind(this);
    this.register = this.register.bind(this);
    Geocode.setApiKey(BaseService.KeyGoogleMap);
  }
  // dispatching an action based on state change
  componentWillUpdate(nextProps, nextState) {
    if (nextProps.editing !== null && nextProps.editing !== this.props.editing) {

      // Convert Date
      var DateBirth = nextProps.editing.birthdate.match(/\d+/g);
      DateBirth = DateBirth['2']+'/'+DateBirth['1']+'/'+DateBirth['0'];

      // Convert Document
      var Document = nextProps.editing.document.replace('/','').replace('.','').replace('.','').replace('-','');

      this.setState({
        name: nextProps.editing.name,
        email: nextProps.editing.email,
        document: Document,
        phone_number: nextProps.editing.phone_number,
        birthdate: DateBirth,
      });
      if(nextProps.editing.device){
        this.setState({
          device: nextProps.editing.device,
          sector: nextProps.editing.sector,
        });
      }
      if(nextProps.api === 'admin/user-admin'){
        this.setState({
          city: (nextProps.editing.cities !== null ? nextProps.editing.cities : null ),
          state: (nextProps.editing.cities !== null ? nextProps.editing.cities.state : null),
          latitude: this.state.latitude,
          longitude: this.state.longitude
        })
      }
      if(nextProps.editing.company_name){
        this.setState({
          company_name: nextProps.editing.company_name,
          address: nextProps.editing.address,
          address_number: nextProps.editing.address_number,
          district: nextProps.editing.district,
          city: nextProps.editing.cities,
          state: nextProps.editing.cities.state,
          cep: nextProps.editing.cep,
          latitude: nextProps.editing.latitude,
          longitude: nextProps.editing.longitude
        });
      }
    }
  }
  toggle(refresh){
    if('geolocation' in navigator){
      const refThis = this
      navigator.geolocation.getCurrentPosition(
        function(position){
          if( position.coords.latitude !== 0 && position.coords.longitude !== 0 ){
            refThis.setState({
              latitude: position.coords.latitude,
              longitude: position.coords.longitude
            });
          }
        },
        function(error){
          console.log(error);
        }
      );
    }
    this.setState({
      user: '',
      user_error: false,
      name: '', nameInvalid: false,
      email: '', emailInvalid: false,
      password: '', passwordInvalid: false,
      repassword: '', repasswordInvalid: false,
      document: '', documentInvalid: false,
      phone_number: '', phoneNumberInvalid: false,
      birthdate: '', birthdateInvalid: false,
      device: '', deviceInvalid: false,
      company_name: '', companyNameInvalid: false,
      address: '', addressInvalid: false,
      district: '', districtInvalid: false,
      address_number: '', addressNumberInvalid: false,
      state: null, stateInvalid: false,
      city: null, cityInvalid: false,
      cep: '', cepInvalid: false,
      sector: '', sectorInvalid: false,
      mask_phone: '(00) 0000-00000',
      loading: false,
      error_message: '',
      color_message: '',
      latitude: 0,
      longitude: 0
    });
    this.props.toggle(refresh);
  }
  handleInputChange (event) {
    // get target
    const target = event.target;
    // if checkbox or input field
    const value = target.type === 'checkbox' ? target.checked: target.value;
    // get tag name
    const name = target.name;
    if(name[0] === 'state'){
      this.setState({
        city: null
      })
    }
    if(name[0] === 'city'){
      if(this.props.api === "admin/user-admin" && (name[0] === 'city' ? value : this.state.city) !== null && (name[0] === 'state' ? value : this.state.state) !== null){
        Geocode.fromAddress((name[0] === 'city' ? value.name : this.state.city.name)+' - '+(name[0] === 'state' ? value.name : this.state.state)).then(
          response => {
            const { lat, lng } = response.results[0].geometry.location;
            this.setState({
              latitude: lat,
              longitude: lng
            });
          },
          error => {
            console.error(error);
          }
        );
      }
    }
    this.setState({
      [name]: value
    });
  }
  /* toggle(refresh){
    this.setState({
      user: '',
      user_error: false,
      name: '', nameInvalid: false,
      email: '', emailInvalid: false,
      password: '', passwordInvalid: false,
      repassword: '', repasswordInvalid: false,
      document: '', documentInvalid: false,
      phone_number: '', phoneNumberInvalid: false,
      birthdate: '', birthdateInvalid: false,
      device: '', deviceInvalid: false,
      company_name: '', companyNameInvalid: false,
      address: '', addressInvalid: false,
      district: '', districtInvalid: false,
      address_number: '', addressNumberInvalid: false,
      state: null, stateInvalid: false,
      city: null, cityInvalid: false,
      cep: '', cepInvalid: false,
      sector: '', sectorInvalid: false,
      mask_phone: '(00) 0000-00000',
      city: null,
      cityInvalid: false,
      state: null,
      stateInvalid: false,
      loading: false,
      error_message: '',
      color_message: '',
      latitude: 0,
      longitude: 0
    });
    this.props.toggle(refresh);
  } */
  valid_field(){
    var invalid = false;
    if (this.state.name.length<3 || this.state.name.length>40) {
      invalid = true;
      this.setState({nameInvalid: true});
    } else {
      this.setState({nameInvalid: false});
    }
    if(this.props.api==='admin/user-access-point'){
       if (this.state.company_name.length<8 || this.state.company_name.length>50) {
        invalid = true;
        this.setState({companyNameInvalid: true});
      } else {
        this.setState({companyNameInvalid: false});
      }
      if (this.state.document.length<18 || this.state.document.length>19) {
        invalid = true;
        this.setState({documentInvalid: true});
      } else {
        this.setState({documentInvalid: false});
      }
    }
    if (this.state.email.length<10 || this.state.email.length>70) {
      invalid = true;
      this.setState({emailInvalid: true});
    } else {
      this.setState({emailInvalid: false});
    }
    if (
      (this.props.editing===null) ||
      (this.props.editing!==null && this.state.password.trim()!=="") ||
      (this.props.editing!==null && this.state.repassword.trim()!=="")
    ){
      if (this.state.password.match(/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{7,}$/) === null) {
        invalid = true;
        this.setState({passwordInvalid: true});
      } else {
        this.setState({passwordInvalid: false});
      }
      if (this.state.repassword.match(/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{7,}$/) === null) {
        invalid = true;
        this.setState({repasswordInvalid: true});
      } else {
        this.setState({repasswordInvalid: false});
      }
      if (this.state.password.match(/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{7,}$/) !== null && this.state.repassword.match(/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{7,}$/) !== null){
        if (this.state.password.trim()!==this.state.repassword.trim()) {
          invalid = true;
          this.setState({passwordInvalid: true});
          this.setState({repasswordInvalid: true});
        } else {
          this.setState({passwordInvalid: false});
          this.setState({repasswordInvalid: false});
        }
      }
    }
    if(this.props.api!=='admin/user-access-point'){
      if (this.state.document.length<13 || this.state.document.length>14) {
        invalid = true;
        this.setState({documentInvalid: true});
      } else {
        this.setState({documentInvalid: false});
      }
    }
    if((this.props.api==='admin/user-agent')||(this.props.api==='admin/user-adviser')){
      if (this.state.device.length<8 || this.state.device.length>20) {
        invalid = true;
        this.setState({deviceInvalid: true});
      } else {
        this.setState({deviceInvalid: false});
      }
      if (this.state.sector===null || this.state.sector.length<=0) {
        invalid = true;
        this.setState({sectorInvalid: true});
      } else {
        this.setState({sectorInvalid: false});
      }
    }
    if(this.props.api==="admin/user-admin")
    { 
      if (this.state.state===null || this.state.state.length<=0) {
        invalid = true;
        this.setState({stateInvalid: true});
      } else {
        this.setState({stateInvalid: false});
      }
      if (this.state.city===null || this.state.city.length<=0) {
        invalid = true;
        this.setState({cityInvalid: true});
      } else {
        this.setState({cityInvalid: false});
      }
    }
    if(this.props.api==='admin/user-access-point'){
      if (this.state.address.length<3 || this.state.address.length>50) {
        invalid = true;
        this.setState({addressInvalid: true});
      } else {
        this.setState({addressInvalid: false});
      }
      if (this.state.address_number<=0 || this.state.address_number>1000000) {
        invalid = true;
        this.setState({addressNumberInvalid: true});
      } else {
        this.setState({addressNumberInvalid: false});
      }
      if (this.state.district.length<2 || this.state.district.length>30) {
        invalid = true;
        this.setState({districtInvalid: true});
      } else {
        this.setState({districtInvalid: false});
      }
      if (this.state.state===null || this.state.state.length<=0) {
        invalid = true;
        this.setState({stateInvalid: true});
      } else {
        this.setState({stateInvalid: false});
      }
      if (this.state.city===null || this.state.city.length<=0) {
        invalid = true;
        this.setState({cityInvalid: true});
      } else {
        this.setState({cityInvalid: false});
      }
      if (this.state.cep.length<8 || this.state.cep.length>30) {
        invalid = true;
        this.setState({cepInvalid: true});
      } else {
        this.setState({cepInvalid: false});
      }
    }
    if (this.state.phone_number.length<15 || this.state.phone_number.length>16) {
      invalid = true;
      this.setState({phoneNumberInvalid: true});
    } else {
      this.setState({phoneNumberInvalid: false});
    }
    if(this.props.api!=='admin/user-access-point'){
      if (this.state.birthdate.length<8 || this.state.birthdate.length>11) {
        invalid = true;
        this.setState({birthdateInvalid: true});
      } else {
        this.setState({birthdateInvalid: false});
      }
    }
    if (this.state.user===null) {
      invalid = true;
      this.setState({user_error: true});
    }

    // Valid inputs
    if(invalid===true){
      return false;
    }

    // Success
    return true;
  }
  register() {
    if (!this.valid_field()) {
      return;
    }
    this.setState({loading: true});
    let url = BaseService.ENDPOINT + this.props.api;
    var msg_success = 'cadastrado';
    if(this.props.editing !== null){
      url += "/"+this.props.editing.id;
      msg_success = 'alterado';
    }
    var form = new FormData();
    form.append("name", this.state.name);
    form.append("email", this.state.email);
    form.append("password", this.state.password);
    form.append("document", this.state.document);
    form.append("phone_number", this.state.phone_number);
    if((this.props.api==='admin/user-agent')||(this.props.api==='admin/user-adviser')){
      var return_sector = [];
      for(var key in this.state.sector) {
        if(key==='id'){
          return_sector = [this.state.sector[key]];
        } else if(key!=='name'){
          return_sector[key] = this.state.sector[key]['id'];
        }
      }
      form.append("device", this.state.device);
      form.append("sector", return_sector);
    }
    if(this.props.api==='admin/user-access-point'){
      form.append("company_name", this.state.company_name);
      form.append("address", this.state.address);
      form.append("address_number", this.state.address_number);
      form.append("district", this.state.district);
      form.append("cep", this.state.cep);
      form.append("city_id", this.state.city.id);
    }
    if(this.props.api!=='admin/user-access-point'){
      form.append("birthdate", this.state.birthdate);
    }
    if(this.props.api === "admin/user-admin")
    {
      form.append("city_id", this.state.city.id);
      form.append("latitude", this.state.latitude);
      form.append("longitude", this.state.longitude);
    }
		return fetch(url, {
      method: 'POST',
      headers: new Headers({
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + this.props.user.access_token,
      }),
      body: form
    })
		.then((response) => response.json())
		.then((json) => {
			if(json.return.code === 1){
        this.setState({
          loading: true,
          error_message: 'Usuário '+msg_success+' com sucesso!',
          color_message: 'success'
        });
      } else if(json.return.code>=300){
        window.location = '/';
      } else {
        this.setState({
          loading: true,
          error_message: json.return.message
        });
      }
		});
  }
  render() {
    let FormGroupCustomerID = '';
    if((this.props.api==='admin/user-agent')||(this.props.api==='admin/user-adviser')){
      FormGroupCustomerID = 
        <div>
          <FormGroup>
            {(this.props.editing!==null?<Label>ID do Celular</Label>:'')}
            <Input
              type="text"
              maxLength={25}
              name="device"
              placeholder="ID do Celular"
              value={this.state.device}
              onChange={this.handleInputChange}
              invalid={this.state.deviceInvalid}>
            </Input>
            <FormFeedback>{Strings.required_field}</FormFeedback>
          </FormGroup>
          <SelectAPI
            label={(this.props.editing!==null?'Selecione um Setor':'')}
            name="sector"
            placeholder={"Selecione um Setor"}
            access_token={this.props.user.access_token}
            api="admin/parking-spot-sector"
            selectedOption={this.handleInputChange}
            value={this.state.sector}
            invalid={this.state.sectorInvalid} 
            formFeedbackMsg={Strings.required_field}
            multi={true}
          />
        </div>;
    }
    let FormGroupDocument = '';
    let FormGroupAccessPoint_Name = '';
    let FormGroupAccessPoint_Address = '';
    let FormGroupAdminAddress = '';
    if(this.props.api==='admin/user-admin'){
      FormGroupAdminAddress = (
        <div>
          <SelectAPI
            label={(this.props.editing!==null?Strings.state:'')}
            name="state"
            placeholder={"Selecione um "+Strings.state}
            access_token={this.props.user.access_token}
            api="admin/states"
            selectedOption={this.handleInputChange}
            value={this.state.state}
            invalid={this.state.stateInvalid} 
            formFeedbackMsg={Strings.required_field}
            multi={false}
          />
          <SelectAPI
            label={(this.props.editing!==null?Strings.city:'')}
            hidden={!(this.state.state !== "")}
            name="city" 
            placeholder={"Selecione uma "+Strings.city}
            access_token={this.props.user.access_token}
            api={"admin/cities/"+(this.state.state==null?'':this.state.state.id)}
            selectedOption={this.handleInputChange}
            value={this.state.city}
            invalid={this.state.cityInvalid} 
            formFeedbackMsg={Strings.required_field}
            multi={false}
          />
        </div>
      );
    }
    if(this.props.api==='admin/user-access-point'){
      FormGroupAccessPoint_Name = (
        <div>
          <FormGroup>
            {(this.props.editing!==null?<Label>Razão Social</Label>:'')}
            <Input
              type="text"
              maxLength={50}
              name="company_name"
              placeholder="Razão Social"
              value={this.state.company_name}
              onChange={this.handleInputChange}
              invalid={this.state.companyNameInvalid} >
            </Input>
            <FormFeedback>{Strings.required_field}</FormFeedback>
          </FormGroup>
          <CustomInput
            label={(this.props.editing!==null?'CNPJ':'')}
            invalid={this.state.documentInvalid}
            mask={"00.000.000/0000-00"}
            name="document"
            placeholder='CNPJ'
            value={this.state.document}
            onChange={(value) => {this.setState({document: value})}}
            unmask={false}
            invalid_message={Strings.required_field}
          />
        </div>
      );
      FormGroupAccessPoint_Address =(
        <div>
          <FormGroup>
            {(this.props.editing!==null?<Label>Endereço</Label>:'')}
            <Input
              type="text"
              maxLength={50}
              name="address"
              placeholder="Endereço"
              value={this.state.address}
              onChange={this.handleInputChange}
              invalid={this.state.addressInvalid} >
            </Input>
            <FormFeedback>{Strings.required_field}</FormFeedback>
          </FormGroup>
          <FormGroup>
            {(this.props.editing!==null?<Label>Número</Label>:'')}
            <Input
              type="int"
              maxLength={50000}
              name="address_number"
              placeholder="Número"
              value={this.state.address_number}
              onChange={this.handleInputChange}
              invalid={this.state.addressNumberInvalid} >
            </Input>
            <FormFeedback>{Strings.required_field}</FormFeedback>
          </FormGroup>
          <SelectAPI
            label={(this.props.editing!==null?Strings.state:'')}
            name="state"
            placeholder={"Selecione um "+Strings.state}
            access_token={this.props.user.access_token}
            api="admin/states"
            selectedOption={this.handleInputChange}
            value={this.state.state}
            invalid={this.state.stateInvalid} 
            formFeedbackMsg={Strings.required_field}
            multi={false}
          />
          <SelectAPI
            label={(this.props.editing!==null?Strings.city:'')}
            hidden={!(this.state.state !== "")}
            name="city" 
            placeholder={"Selecione uma "+Strings.city}
            access_token={this.props.user.access_token}
            api={"admin/cities/"+(this.state.state==null?'':this.state.state.id)}
            selectedOption={this.handleInputChange}
            value={this.state.city}
            invalid={this.state.cityInvalid} 
            formFeedbackMsg={Strings.required_field}
            multi={false}
          />
          <FormGroup>
            {(this.props.editing!==null?<Label>Bairro</Label>:'')}
            <Input
              type="text"
              maxLength={30}
              name="district"
              placeholder="Bairro"
              value={this.state.district}
              onChange={this.handleInputChange}
              invalid={this.state.districtInvalid} >
            </Input>
            <FormFeedback>{Strings.required_field}</FormFeedback>
          </FormGroup>
          <CustomInput
            label={(this.props.editing!==null?'CEP':'')}
            invalid={this.state.cepInvalid}
            mask={"00000-000"}
            name="cep"
            placeholder='CEP'
            value={this.state.cep}
            onChange={(value) => {this.setState({cep: value})}}
            unmask={false}
            invalid_message={Strings.required_field}
          />
        </div>
      );
    } else {
      FormGroupDocument = 
        <CustomInput
          label={(this.props.editing!==null?'CPF':'')}
          hidden={this.props.api==='admin/user-access-point'}
          invalid={this.state.documentInvalid}
          mask={"000.000.000-00"}
          name="document"
          placeholder='CPF'
          value={this.state.document}
          onChange={(value) => {this.setState({document: value})}}
          unmask={false}
          invalid_message={Strings.required_field}
        />
    }
    let FormGroupBirthDate = '';
    if(this.props.api!=='admin/user-access-point'){
      FormGroupBirthDate = (
        <CustomInput
          label={(this.props.editing!==null?'Data de Nascimento':'')}
          invalid={this.state.birthdateInvalid}
          mask={"00/00/0000"}
          name="birthdate"
          placeholder='Data de Nascimento'
          value={this.state.birthdate}
          onChange={(value) => {this.setState({birthdate: value})}}
          unmask={false}
          invalid_message={Strings.required_field}
        />
      );
    }
    return (
      <Modal isOpen={this.props.visible} >
        <ModalHeader>{(this.props.editing!==null?'Editar':'Criar')} Usuário {this.props.title}</ModalHeader>
          <ModalBody hidden={this.state.loading}>
            <Form>
              <FormGroup>
                {(this.props.editing!==null?<Label>{(this.props.api==='admin/user-access-point'?'Nome Fantasia':'Nome')}</Label>:'')}
                <Input
                  type="text"
                  maxLength={50}
                  name="name"
                  placeholder={(this.props.api==='admin/user-access-point'?'Nome Fantasia':'Nome')}
                  value={this.state.name}
                  onChange={this.handleInputChange}
                  invalid={this.state.nameInvalid} >
                </Input>
                <FormFeedback>{Strings.required_field}</FormFeedback>
              </FormGroup>
              {FormGroupAccessPoint_Name}
              <FormGroup>
                {(this.props.editing!==null?<Label>E-mail</Label>:'')}
                <Input
                  type="text"
                  maxLength={70}
                  name="email"
                  placeholder="E-mail"
                  value={this.state.email}
                  onChange={this.handleInputChange}
                  invalid={this.state.emailInvalid}
                ></Input>
                <FormFeedback>{Strings.required_field}</FormFeedback>
              </FormGroup>
              <FormGroup>
                {(this.props.editing!==null?<Label>Senha</Label>:'')}
                <Input
                  type="password"
                  maxLength={70}
                  name="password"
                  placeholder="Senha"
                  value={this.state.password}
                  onChange={this.handleInputChange}
                  invalid={this.state.passwordInvalid}
                ></Input>
                <FormFeedback>{this.state.required_password}</FormFeedback>
              </FormGroup>
              <FormGroup>
                {(this.props.editing!==null?<Label>Repita a Senha</Label>:'')}
                <Input
                  type="password"
                  maxLength={70}
                  name="repassword"
                  placeholder="Repita a Senha"
                  value={this.state.repassword}
                  onChange={this.handleInputChange}
                  invalid={this.state.repasswordInvalid}
                ></Input>
                <FormFeedback>{this.state.required_repassword}</FormFeedback>
              </FormGroup>
              {FormGroupAccessPoint_Address}
              {FormGroupDocument}
              {FormGroupCustomerID}
              <CustomInput
                label={(this.props.editing!==null?'Telefone':'')}
                invalid={this.state.phoneNumberInvalid}
                mask={this.state.mask_phone}
                name="phone_number"
                placeholder='Telefone'
                value={this.state.phone_number}
                onChange={(value) => {
                  this.setState({
                    phone_number: value,
                    mask_phone: (value.length>14?'(00) 00000-0000':'(00) 0000-00000')
                  });
                }}
                unmask={false}
                invalid_message={Strings.required_field}
              />
              {FormGroupBirthDate}
              {FormGroupAdminAddress}
            </Form>
          </ModalBody>
          <Loader
            body={ModalBody}
            hidden={!this.state.loading}
            message={this.state.error_message}
            color_message={this.state.color_message}
            onClose={() => this.setState({loading: false, error_message: '', color_message: ''})}
            onCloseSuccess={() => {this.toggle(true); this.setState({loading: false, error_message: '', color_message: ''});}}
          />
          <ModalFooter hidden={this.state.loading} >
            <Button outline color="secondary" onClick={this.register}>Salvar</Button>
            <Button outline color="danger" onClick={ () => this.toggle(false)}>Cancelar</Button>
        </ModalFooter>
      </Modal>
    )
  }
}
export default UserCreate;


// WEBPACK FOOTER //
// ./src/components/UserCreate.js